import React from 'react';
import { defaultSchema } from '@atlaskit/adf-schema/schema-default';
import { ReactRenderer } from '@atlaskit/renderer';
import { fg } from '@atlassian/jira-feature-gating';
import {
	onLinkClick,
	smartLinksDefault,
} from '@atlassian/jira-linking-platform-utils/src/index.tsx';
import type { Props } from './types.tsx';

const MessageCFBehaviour = (props: Props) => {
	const { defaultValue } = props;
	if (defaultValue === undefined) {
		return null;
	}

	return (
		<ReactRenderer
			document={defaultValue}
			schema={defaultSchema}
			disableHeadingIDs
			eventHandlers={{
				smartCard: { onClick: onLinkClick },
				link: { onClick: onLinkClick },
			}}
			featureFlags={{
				codeBidiWarnings: true,
				'code-bidi-warnings': true,
				// enables sending analytics event with renderer specific tti measurement
				// please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
				'renderer-tti-tracking': fg('renderer_tti_tracking_jira'),
			}}
			smartLinks={smartLinksDefault}
		/>
	);
};

const MessageCF = (props: Props) => <MessageCFBehaviour key="message-custom-field" {...props} />;

export default MessageCF;
